export const tokens = {
    ticker: {
        gap: 6,
        // TODO: This needs to be informed by the global mobile nav.
        bottom: 80,
        padding: 16,
    },
    closeAction: {
        padding: 18,
        height: 26,
        labelSize: 12,
    },
    openAction: {
        size: 44,
        iconSize: 16,
    },
    sweepControls: {
        gap: 6,
    },
    fieldNumber: {
        size: 16,
    },
    sweepAction: {
        gap: 6,
        padding: 12,
        height: 36,
        labelSize: 16,
    },
    sweepCurrency: {
        size: 18,
        iconSize: 14,
    },
};
